import { useEffect, useState } from 'react';
import { Link, useParams } from 'react-router-dom';
import { supabase } from '@/lib/supabase';
import ProductForm from '@/pages/products/components/ProductForm';
import type { Product } from '@/lib/types';

export default function ProductDetailPage() {
  const { id } = useParams<{ id: string }>();
  const [product, setProduct] = useState<Product | null>(null);
  const [loading, setLoading] = useState(true);
  const [error, setError] = useState<string | null>(null);

  useEffect(() => {
    let active = true;
    const load = async () => {
      setLoading(true);
      setError(null);
      try {
        const { data, error: e } = await supabase
          .from('products')
          .select('*, category:categories(id, name)')
          .eq('id', id)
          .maybeSingle();
        if (e) throw e;
        if (active) setProduct((data as Product) ?? null);
      } catch (err) {
        if (active) setError(err instanceof Error ? err.message : 'No se pudo cargar el producto');
      } finally {
        if (active) setLoading(false);
      }
    };
    load();
    return () => {
      active = false;
    };
  }, [id]);

  return (
    <div>
      <Link
        to="/products"
        className="inline-flex items-center gap-1.5 text-sm font-medium text-foreground-600 hover:text-foreground-900 transition cursor-pointer"
      >
        <i className="ri-arrow-left-line" /> Volver a productos
      </Link>
      <h1 className="mt-2 font-heading text-2xl md:text-3xl font-bold text-foreground-950">
        {product ? product.name : 'Detalle del producto'}
      </h1>
      <p className="mt-1 text-foreground-600">Edita la información del producto.</p>

      <div className="mt-6">
        {loading ? (
          <div className="flex items-center justify-center py-16">
            <div className="w-10 h-10 rounded-full border-2 border-primary-500 border-t-transparent animate-spin" />
          </div>
        ) : error ? (
          <div className="rounded-lg border border-accent-200 bg-accent-50 px-4 py-3 text-sm text-foreground-700">
            {error}
          </div>
        ) : product ? (
          <ProductForm product={product} />
        ) : (
          <div className="rounded-lg border border-dashed border-background-300 p-10 text-center text-foreground-600">
            Producto no encontrado.
          </div>
        )}
      </div>
    </div>
  );
}